import React from 'react';
import { SellFund } from 'src/redux/modules/sellTransaction/types';
import { UNIT } from 'src/settings/settings';
import { currency } from 'src/utils/utils';
import words from 'src/utils/words';
import If from 'src/components/Shared/If/If';
import './SellSelectedFundAmount.scss';

export interface SellSelectedFundAmountProps {
  fund: SellFund;
  showHeader?: boolean;
}

export const SellSelectedFundAmount: React.FC<SellSelectedFundAmountProps> = ({
  fund: { grossAmountDollars, grossUnit, grossAmount, grossPercentShares },
  showHeader = true,
}) => (
  <div className="sell-selected-fund-amount">
    <div className="sell-selected-fund-amount-display">
      {showHeader && <span className="hidden-lg hidden-md"> AMOUNT: </span>}
      <span className="sell-selected-fund-amount-gross-amount">
        {currency(grossAmountDollars)}
      </span>
    </div>

    <If test={grossUnit === UNIT.PERCENT}>
      <If test={grossAmount < 100}>
        <div className="sell-selected-fund-amount-gross-unit">
          {`${grossAmount}% (${grossPercentShares} ${words.shares})`}{' '}
        </div>
      </If>
      <If test={grossAmount === 100}>
        <div className="sell-selected-fund-amount-gross-unit">
          All Available {words.Shares}
        </div>
      </If>
    </If>
    <If test={grossUnit === UNIT.SHARES}>
      <div className="sell-selected-fund-amount-gross-unit">
        {grossAmount} {words.shares}
      </div>
    </If>
  </div>
);

export default SellSelectedFundAmount;
